import { css } from 'styled-components/macro';

export const flexCenter = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const positionAbsolute = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
